var p = /* @__PURE__ */ ((r) => (r.PDP = "pdp", r.SHARE = "share", r.MYLIST = "mylist", r.POSTPURCHASE = "postpurchase", r))(p || {}), P = /* @__PURE__ */ ((r) => (r["1.0.0"] = "1.0.0", r))(P || {});
export {
  p as ShareEventsEnum,
  P as ShareEventsVersionsEnum
};
//# sourceMappingURL=types.js.map
